import MiniCalendarProvider from './contexts/MiniCalendarContext/Provider'
import Component from './Component'

export default function MiniCalendar({ ...props }) {
  return (
    <MiniCalendarProvider {...props}>
      <Component {...props} />
    </MiniCalendarProvider>
  )
}
